import { AxiosError } from 'axios';
import { useMutation } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';

export interface ActivateUserData {
  email: string;
  activation_code: string;
  password: string;
}

export const useActivateUser = () => {
  const activateUser = async (data: ActivateUserData): Promise<void> => {
    const url = `${POST_URL().activate}`;
    await Axios.post(url, data);
  };

  return useMutation<void, AxiosError<BaseError>, ActivateUserData>(
    (data: ActivateUserData) => activateUser(data)
  );
};
